export default "__VITE_ASSET__KykGhtHL__"